module.exports = __webpack_public_path__ + "img/no-results.89ee11f2.png";